import { faUserCircle } from "@fortawesome/pro-light-svg-icons";

import { EntityCaseSummaryStatusEnum } from "src/clients/entities/api";
import { Pill } from "src/design-system/Pill";

type EntityReviewStatusProps = {
  status: EntityCaseSummaryStatusEnum;
};

export const EntityReviewStatus = ({ status }: EntityReviewStatusProps) => {
  const reviewRequired = status === EntityCaseSummaryStatusEnum.REVIEW_REQUIRED;

  return (
    <div className="pr-1">
      <Pill size="sm" variant={reviewRequired ? "indigo-light" : "gray"}>
        <Pill.Icon icon={faUserCircle} />
        <Pill.Text>
          {reviewRequired ? "Review required" : "No pending reviews"}
        </Pill.Text>
      </Pill>
    </div>
  );
};
